import { ManagerTabsType } from "@/components/ManagerComponents/types";
import { makeVar } from "@apollo/client";
import { Project, Event } from "./generated/graphql";

const MANAGER_LAST_OPEN_TAB_STORAGE_KEY = 'overwatch:managerLastOpenTab';
export const DEFAULT_ACTIVE_TAB = 'Dashboard';

export type ModalType = 'Note' | 'CreateEvent' | 'Project' | 'CreateProject' | 'Task' | 'Meeting' | 'KickOff' | 'EditReport' | 'ViewReport' | 'CreateTask' | 'CreateNote';

export const setOpenedModals = makeVar<ModalType[]>([]);

export const getActiveTab = (): ManagerTabsType =>
  (localStorage.getItem(MANAGER_LAST_OPEN_TAB_STORAGE_KEY) as ManagerTabsType | null)
  ?? DEFAULT_ACTIVE_TAB;

export const activeTabVar = makeVar<ManagerTabsType>(getActiveTab());

export const setActiveTab = (tab: ManagerTabsType) => {
  localStorage.setItem(MANAGER_LAST_OPEN_TAB_STORAGE_KEY, tab);
  activeTabVar(tab);
};

export const openKickOffDocumentDrawer = makeVar<boolean>(false);

export const selectedProject = makeVar<Project | undefined>(undefined);

export const selectedEvent = makeVar<Event | undefined>(undefined);
